import {FormFieldBase} from './base/form-field-base';

export class MockInput extends FormFieldBase<string> {
  controlType = 'mock';
  type = 'mock';
}

